<div [ngSwitch]="formField">
  <div *ngSwitchCase="'label'">
    <label class="label" [ngClass]="hasFieldError() == true ? 'text-danger' : null">{{
      label
      }}</label> <br>
    <div [innerHTML]="value"></div>
  </div>

  <div *ngSwitchCase="'textbox'">

    <label class="label" [ngClass]="hasFieldError() == true ? 'text-danger' : null">{{label}}</label> <br>

    <mat-form-field appearance="outline" class="form-field custom-input">
      <input matInput
             [type]="type? type : 'text'"
             [formControl]="control">

      <span matTextSuffix *ngIf="suffix">{{suffix}}</span>

      <mat-hint class="small" *ngIf="!hasFieldError() && !this.control.touched">
        Please fill in <span class="material-indigo"><b>{{ label | titlecase }}</b></span>
      </mat-hint>
      <mat-hint class="small text-danger" *ngIf="hasFieldError() && control.hasError('required')">
        <b>{{ label | titlecase }}</b> is required
      </mat-hint>
      <mat-hint class="small text-danger" *ngIf="hasFieldError() && control.hasError('email')">
        Please enter a valid email address
      </mat-hint>
      <mat-hint class="small text-danger" *ngIf="hasFieldError() && control.hasError('skuExists')">
        Sku no already exist
      </mat-hint>
    </mat-form-field>
  </div>

  <div *ngSwitchCase="'password'">
    <label class="label" [ngClass]="hasFieldError() == true ? 'text-danger' : null">{{
      label
      }}</label> <br>

    <mat-form-field appearance="outline" class="form-field">
      <input matInput
             [type]="hide? 'password' : 'text'"
             [formControl]="control">

      <mat-icon *ngIf="!hide" matSuffix (click)="hide = !hide"><i class="bi bi-eye-slash"></i></mat-icon>
      <mat-icon *ngIf="hide" matSuffix (click)="hide = !hide"><i class="bi bi-eye"></i></mat-icon>

      <mat-hint class="small" *ngIf="!hasFieldError() && !this.control.touched">
        Please fill in <span class="material-indigo"><b>{{ label | titlecase }}</b></span>
      </mat-hint>
      <mat-hint class="text-danger small" *ngIf="hasFieldError() && control.hasError('required')">
        <b>{{ label | titlecase }}</b> is required
      </mat-hint>
      <mat-hint class="text-danger small" *ngIf="hasFieldError() && control.hasError('match')">
        <b>{{ label | titlecase }}</b> is not match
      </mat-hint>
    </mat-form-field>
  </div>

  <div *ngSwitchCase="'textarea'">
    <label class="label" [ngClass]="hasFieldError() == true ? 'text-danger' : null">{{
      label
      }}</label> <br>

<!--    <mat-form-field appearance="outline" class="form-field">-->
        <textarea matInput
                  type="text"
                  [formControl]="control">
        </textarea>

      <mat-hint class="small" *ngIf="!hasFieldError()">
        Please fill in <span class="material-indigo"><b>{{ label | titlecase }}</b></span>
      </mat-hint>
      <mat-hint class="text-danger small" *ngIf="hasFieldError() && control.hasError('required')">
        <b>{{ label | titlecase }}</b> is required
      </mat-hint>
<!--    </mat-form-field>-->
  </div>

  <div *ngSwitchCase="'dropdown'">
    <label class="label" [ngClass]="hasFieldError() == true ? 'text-danger' : null">{{
      label
      }}</label> <br>

    <mat-form-field appearance="outline" class="form-field">
      <mat-select
        [formControl]="control" (selectionChange)="changeOption($event)">
        <mat-option [value]="defaultValue">
          Please Select {{ label | titlecase }}
        </mat-option>
        <mat-option *ngFor="let opt of options" [value]="convertNumber(opt.key)">
          {{ opt.value | titlecase }}
        </mat-option>
      </mat-select>

      <mat-hint class="small" *ngIf="!hasFieldError()">
        Please Select <span class="material-indigo"><b>{{ label | titlecase }}</b></span>
      </mat-hint>
      <mat-hint class="text-danger small" *ngIf="hasFieldError()">
        <b>{{ label | titlecase }}</b> is required
      </mat-hint>
    </mat-form-field>

  </div>

  <div *ngSwitchCase="'dropdown-select'">
    <label class="label" [ngClass]="hasFieldError() == true ? 'text-danger' : null">{{
      label
      }}</label> <br>

    <mat-form-field appearance="outline" class="form-field">
      <mat-select
              [formControl]="control" (selectionChange)="changeOption($event)" multiple>
        <mat-option [value]="defaultValue" (click)="selectAll(control)">
         All {{ label | titlecase }}
        </mat-option>
        <mat-select-trigger>
          {{control.value?.[0] || ''}}
          <span *ngIf="(control.value?.length || 0) > 1" class="example-additional-selection">
            (+{{(control.value?.length || 0) - 1}} {{control.value?.length === 2 ? 'other' : 'others'}})
          </span>
        </mat-select-trigger>
        <mat-option *ngFor="let opt of options" [value]="convertNumber(opt.key)">
          {{ opt.value | titlecase }}
        </mat-option>
      </mat-select>

      <mat-hint class="small" *ngIf="!hasFieldError()">
        Please Select <span class="material-indigo"><b>{{ label | titlecase }}</b></span>
      </mat-hint>
      <mat-hint class="text-danger small" *ngIf="hasFieldError()">
        <b>{{ label | titlecase }}</b> is required
      </mat-hint>
    </mat-form-field>

  </div>

  <div *ngSwitchCase="'checkbox'">
    <label style="margin-bottom: 0;" class="label" [ngClass]="hasFieldError() == true ? 'text-danger' : null">{{
      label
      }}</label> <br>

    <mat-checkbox class="example-margin" [color]="'primary'"
                  [formControl]="control" style="margin-bottom: 0 !important;">
      {{ label | titlecase }}
    </mat-checkbox> <br>
    <mat-hint class="small" *ngIf="!hasFieldError()">
      <small>Please Select <span class="material-indigo"><b>{{ label | titlecase }}</b></span></small>
    </mat-hint>
    <mat-hint class="text-danger small" *ngIf="hasFieldError() && control.hasError('required')">
      <small><b>{{ label | titlecase }}</b> is required</small>
    </mat-hint>
  </div>

  <div *ngSwitchCase="'radio'">
    <label class="label" [ngClass]="hasFieldError() == true ? 'text-danger' : null">{{
      label
      }}</label> <br>
    <mat-radio-group
      aria-labelledby="example-radio-group-label"
      class="example-radio-group"
      [formControl]="control">
      <mat-radio-button class="example-radio-button"  *ngFor="let opt of options"
                        [value]="convertNumber(opt.key)">
        {{ opt.value | titlecase }}
      </mat-radio-button>
      <mat-hint class="small" *ngIf="!hasFieldError()">
        <small>Please Select <span class="material-indigo"><b>{{ label | titlecase }}</b></span> </small>
      </mat-hint>
      <mat-hint class="text-danger small" *ngIf="hasFieldError() && control.hasError('required')">
        <small> <b>{{ label | titlecase }}</b> is required</small>
      </mat-hint>
    </mat-radio-group>
  </div>

  <div *ngSwitchCase="'datepicker'">
    <label class="label" [ngClass]="hasFieldError() == true ? 'text-danger' : null">{{
      label
      }}</label> <br>

    <mat-form-field appearance="outline" class="form-field">
      <input matInput [matDatepicker]="picker"
             [formControl]="control">
      <mat-datepicker-toggle matIconSuffix [for]="picker"></mat-datepicker-toggle>
      <mat-hint class="small" *ngIf="!hasFieldError()">
        Please Select <span class="material-indigo"><b>{{ label | titlecase }}</b></span>
      </mat-hint>
      <mat-hint class="text-danger small" *ngIf="hasFieldError() && control.hasError('required')">
        <b>{{ label | titlecase }}</b> is required
      </mat-hint>
      <mat-datepicker #picker></mat-datepicker>
    </mat-form-field>
  </div>

  <div *ngSwitchCase="'timepicker'">
    <label class="label" [ngClass]="hasFieldError() == true ? 'text-danger' : null">{{
        label
      }}</label> <br>

    <mat-form-field appearance="outline" class="form-field">
      <input matInput [ngxTimepicker]="picker" [format]="24"
             [formControl]="control">
      <ngx-material-timepicker #picker [format]="24"></ngx-material-timepicker>
      <mat-hint class="small" *ngIf="!hasFieldError()">
        Please Select <span class="material-indigo"><b>{{ label | titlecase }}</b></span>
      </mat-hint>
      <mat-hint class="text-danger small" *ngIf="hasFieldError() && control.hasError('required')">
        <b>{{ label | titlecase }}</b> is required
      </mat-hint>
    </mat-form-field>


  </div>

  <div *ngSwitchCase="'autocomplete'">
    <label class="label" [ngClass]="hasFieldError() == true ? 'text-danger' : null">{{
      label
      }}</label> <br>

    <mat-form-field appearance="outline" class="form-field">
      <input
        type="text"
        aria-label="Number"
        matInput
        [matAutocomplete]="autoComplete"
        #searchConsumerInput
        (input)="searchAutocomplete($event)"
        [formControl]="control">
      <nb-icon matSuffix icon="search-outline" class="mb-3 mr-2 text-muted"></nb-icon>
      <i *ngIf="loadingAutocomplete" matSuffix class="fas fa-spinner fa-spin fa-2x fa-fw"></i>

      <mat-autocomplete #autoComplete="matAutocomplete">
        <mat-option
          *ngFor="let data of autocompleteList"
          [value]="convertNumber(data.key)"
          (onSelectionChange)="changeAutocomplete(data, $event)">
          <div class="mb-2">
            <span style="font-weight: 400">{{ data.value }}</span> <br>
            <span *ngFor="let ref of data.ref; let last = last;" class="text-muted small">
                {{ref.key}} :  {{ref.value}}
              <span *ngIf="!last">|</span>
              </span>
          </div>
        </mat-option>
      </mat-autocomplete>
      <mat-hint class="small" *ngIf="!hasFieldError()">
        Please Select <span class="material-indigo"><b>{{ label | titlecase }}</b></span>
      </mat-hint>
      <mat-hint class="text-danger small" *ngIf="hasFieldError()">
        <b>{{ label | titlecase }}</b> is required
      </mat-hint>
    </mat-form-field>
  </div>

</div>
